import {  Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { DynamicFormComponent } from 'src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component';
import { FieldConfig } from 'src/app/CommonComponents/dynamic-form/interface/field.interface';
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { TenderQuantityService } from 'src/app/Service/tender-quantity/tender-quantity.service';
import { Module } from 'src/app/Service/element-details.data.service';


@Component({
  selector: 'app-tender-quantity-add-data',
  templateUrl: './tender-quantity-add-data.component.html',
  styleUrls: ['./tender-quantity-add-data.component.css']
})

export class TenderQuantityAddDataComponent implements OnInit  {
  
  public currentPlaceHolder: string | undefined;
  public activeStatus: boolean = true;
  public newDescription: any;
  public currentActionpage: string | undefined;
  public suggestionValue: any[] = [];
  public tenderQuantityConfig: FieldConfig[] = [];
  public selectedDescription: any={};
  public postSelect :any;
  public keyword: any; 
  public elementList: any[] = [];
  public itemList: any[] = [];
  public elementsearch: any;
  public itemsearch: any;
  public updatedDescription!: string;
  public section1: boolean = true;
  public section2: boolean = false;
  public setSelectedElementId!: number;
  public setSelectedItemId!: number;
  public discipline: any;
  public selectElement!: string;
  public selectitem!: string;
  public elementListId: any;
  public show :boolean =  false;
  public editDiscipline!: string;
  public Description :any;
  public ItemDescription :any;
  public elementId: number | null | undefined;
  public itemId: number | null | undefined;
  public setDisable:boolean = false;


  private dynamicFormComponent!: DynamicFormComponent;


  @ViewChild('dynamicFormComponent') set content(content: DynamicFormComponent) {  
    if (!!content) {  
      this.dynamicFormComponent = content;
      this.getDynamicform();
      this.dynamicFormComponent.form.get('Discipline')?.valueChanges.subscribe(data => {       
        if(!!data){
        this.discipline = data.dedId;
      }else{
        this.discipline = null;
        this.elementId = null;                   
        this.itemId = null; 
      }
      });         
    }
  }

  constructor(@Inject(MAT_DIALOG_DATA) public _data: any,private _projectService: ProjectInfoService,
     private commonService: CommonService,
    public dialogRef: MatDialogRef<TenderQuantityAddDataComponent>,private tenderQuantityService: TenderQuantityService,
    public notificationService: NotificationService){    
    
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.currentpage();
  }

  currentpage() {  
    switch (this._data.currentpage) {
      case "element": {
        this.currentActionpage = " Add or Edit New Element";
        this.currentPlaceHolder = " Enter New Element";
        this.keyword = 'tE_Description';
        this.suggestionValue = this._data.existData;
        if (!!this._data.value) {
          this.newDescription = this._data.value.tE_Description;
          this.selectedDescription = this._data.value;         
          this.activeStatus = (this._data.value.active_Tag.toUpperCase() == "Y") ? true : false; 
        }
        break;
      }
      case "items": {
        this.currentActionpage = "Add or Edit New Items";
        this.currentPlaceHolder = " Enter New Item";
        this.keyword = 'tI_Description';
        this.suggestionValue = this._data.existData;
        if (!!this._data.value) {
          this.newDescription = this._data.value.tI_Description;
          this.selectedDescription = this._data.value;         
          this.activeStatus = (this._data.value.active_Tag.toUpperCase() == "Y") ? true : false; 
        }
        break;
      }
      case "Configure": {          
        this.dynamicFormComponent;          
        this.elementList = this._data.configureValue.elementList;
        this.elementsearch = 'tE_Description';
        this.itemsearch = 'tI_Description';
        this.section1 = false;
        this.section2 = true;
        this.currentActionpage = " Add or Edit New Configure";
        this.itemList = this._data.configureValue.ItemsList;
        if (!!this._data.value) {
          this.show = true;  
          this.setDisable = true;
          this.elementListId = this._data.value;
          this.currentPlaceHolder = "Select Element Description";
          this.elementId = this._data.value.tE_Id;                   
          this.itemId = this._data.value.tI_Id;      
          this.activeStatus = (this._data.value.active_Tag.toUpperCase() == "Y") ? true : false;    
          this.editDiscipline = this._data.value.deD_Description;
        }
        break;
      }
    }
  }



  addNewValue() {  
    let existValue:[]=[]; 
    let status:string;
    if(this.activeStatus ==true){
     status ="Y";
    }else{
      status ="N";
    }  
    let obj = { Id: 0, description: this.updatedDescription, isActive: status }
      switch (this._data.currentpage) {
        case "element": {             
          if(!this.newDescription){
            this.notificationService.showPopup("Please "+this.currentPlaceHolder, "Warning");
            return;
           }
          if(!this.updatedDescription){
            this.notificationService.showPopup("Select Any Description", "Warning");
            return;
          }      
          existValue = this.suggestionValue.filter(element =>element.tE_Description == this.updatedDescription )[0];
         if(!existValue){          
          this.tenderQuantityService.PostOrEditElementDataToDp(obj).subscribe(data => {
            if (data.successCode == 200) {
              this.notificationService.showToast(data.successMessage, "Success");
              this.closeDialog();
              return;
            }
          });
        }else{
          this.notificationService.showPopup("Description Already Exists", "Warning");
        }      
        break;
        }
        case "items": {
          if(!this.newDescription){
            this.notificationService.showPopup("Please "+this.currentPlaceHolder, "Warning");
            return;
           }
          if(!this.updatedDescription){
            this.notificationService.showPopup("Select Any Description", "Warning");
            return;
          }
          existValue = this.suggestionValue.filter(element => element.tI_Description == this.updatedDescription )[0];
          if(!existValue){ 
          this.tenderQuantityService.insetorPostOrEditItemDataToDp(obj).subscribe(data => {
            if (data.successCode == 200) {
              this.notificationService.showToast(data.successMessage, "Success");
              this.closeDialog();
              return;
            }
          });
        }else{
          this.notificationService.showPopup("Description Already Exists", "Warning");
        }
          break;
        }
        case "Configure": {             
          if(!this.discipline){
            this.notificationService.showPopup("Please select any one Discipline", "Warning");
            return;
          }
          if(!this.elementId){
            this.notificationService.showPopup("Please select any one Element", "Warning");
            return;
          }
          if(!this.itemId){
            this.notificationService.showPopup("Please select any one Item", "Warning");
            return;
          }
          let obj = {
            "disc_DED_Id": this.discipline,
            "tE_Id":   this.elementId ,
            "tI_Id": this.itemId,
            "isActive": status
          }        
          this.tenderQuantityService.InsetConfigureDiscipline(obj).subscribe(data => {
            if (data.successCode == 200) {
              this.notificationService.showToast(data.successMessage, "Success");
              this.closeDialog();
              return;
            }
          });
          break;
        }
      }  
  }

  onChangeSearch(val:any){   
    this.updatedDescription = val;  
  }

  selectEvent(item: any) { 
    if(!!item.tE_Description)
    this.updatedDescription = item.tE_Description;   
    if(!!item.tI_Description)
    this.updatedDescription = item.tI_Description;  
  }

 
  postData(item?: any) {
    if (!this._data.value) {
      this.addNewValue();       
    } else {
      this.updateValue();
    }
  }


  updateValue() {    
    let status: string;     
    if(this.activeStatus == true){
      status ="Y";
     }else{
       status ="N";
     }      
    switch (this._data.currentpage) {            
      case "element": {           
        let UpdatedDescription:String;  
        UpdatedDescription = this._data.value.tE_Description; 
        if(!!this.updatedDescription){
          UpdatedDescription = this.updatedDescription;
        }   
        let existValue = this.suggestionValue.filter(element => element.tE_Description == UpdatedDescription && element.active_Tag == status)[0];
        let obj = { tE_Id : this._data.value.tE_Id,description: UpdatedDescription,  isActive: status };             
        if (!!existValue) {
          this.notificationService.showPopup("Description Already Exists", "Warning");
        } else {        
          this.tenderQuantityService.PostOrEditElementDataToDp(obj).subscribe(data => {
            if (data.successCode == 200) {
              this.notificationService.showToast(data.successMessage, "Success");
              this.closeDialog();
              return;
            }
          });
        }
        break;
      }
      case "items": { 
        let UpdatedDescription:String;
        UpdatedDescription = this._data.value.tI_Description; 
        if(!!this.updatedDescription){
          UpdatedDescription = this.updatedDescription;
        }      
        let existValue: [] = this.suggestionValue.filter(element => element.tI_Description == UpdatedDescription && element.active_Tag == status)[0];
        let obj = { tI_Id: this._data.value.tI_Id, description: UpdatedDescription,  isActive: status };    
        if (!!existValue) {
          this.notificationService.showPopup("Description Already Exists ", "Warning");
        } else {
          this.tenderQuantityService.insetorPostOrEditItemDataToDp(obj).subscribe(data => {            
            if (data.successCode == 200) {
              this.closeDialog();
              this.notificationService.showToast(data.successMessage, "Success");
              return;
            }
          });
        }
        break;
      }
      case "Configure": {    
         if(!!this._data &&  !!this._data.value.disc_DED_Id){
          this.discipline = this._data.value.disc_DED_Id;
        }  
        let obj = {
          "disc_DED_Id": this.discipline,
          "tE_Id": this._data.value.tE_Id,
          "tI_Id": this._data.value.tI_Id,
          "isActive": status
        }      
        this.tenderQuantityService.InsetConfigureDiscipline(obj).subscribe(data => {
          if (data.successCode == 200) {
            this.notificationService.showToast(data.successMessage, "Success");
            this.closeDialog();           
          }
        });
        break;
      }
    }   
  }

 

  getTenderQuantitySetFieldsConfig(): FieldConfig[] {
    return [
      {
        type: 'select',
        name: 'Discipline',
        label: 'Discipline',
        deDescription: 'discipline',
        module_id: Module.ScheduleDocument,
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Please select discipline"
          }
        ],
        value: new BehaviorSubject(null)
      }
    ]
  };
   
  getDynamicform() {
    this.tenderQuantityConfig = this.getTenderQuantitySetFieldsConfig();
    this.dynamicFormComponent.fields = this.tenderQuantityConfig;
    this.dynamicFormComponent.createControl();
  };

}
